export default __webpack_public_path__ + "static/media/check.7fc07d79.svg";